import Dashboard from 'pages/authenticated/dashboard/Dashboard';
import Users from 'pages/authenticated/users/Users';
import Bots from 'pages/authenticated/bots/Bots';
import KnowledgeBase from 'pages/authenticated/knowledge-base/KnowledgeBase';
import ChatConsole from 'pages/authenticated/chat-console/ChatConsole';
import Branding from 'pages/authenticated/branding';
import ChatSettings from 'pages/authenticated/chat-settings/ChatSettings';
import CompanyProfile from 'pages/authenticated/company-pofile/CompanyProfile';
import NewUser from 'pages/authenticated/users/new-user/NewUser';
import UserProfile from 'pages/authenticated/users/single-user/UserProfile';
import Profile from 'pages/authenticated/profile/Profile';
import NewGroup from 'pages/authenticated/users/new-group/NewGroup';
import BotBranding from 'pages/authenticated/settings/branding/BotBranding';
import SensitiveKeyword from 'pages/authenticated/settings/sensitiveKeywords/SensitiveKeyword';
import TermsAndConditions from 'pages/authenticated/settings/Terms&Conditions/TermsAndConditions';
import VoiceRecording from 'pages/authenticated/settings/VoiceRecordings/VoiceRecording';
import LinkToAgent from 'pages/authenticated/settings/link-to-agent/LinkToAgent';
import FormResponses from 'pages/authenticated/settings/form-responses/FormResponses';
import Analytics from 'pages/authenticated/settings/analytics/Analytics';
import ThemeSettings from 'pages/authenticated/settings/botTheme/ThemeSettings';
import Categories from 'pages/authenticated/settings/categories/Categories';
import SettingsWorkflows from 'pages/authenticated/settings/workflow/SettingsWorkflows';
import VariableManagement from 'pages/authenticated/variable-management/VariableManagement';
import NewForm from 'pages/authenticated/settings/form-responses/NewForm';
import WorkflowProviderView from 'pages/authenticated/work-flow/WorkFlow';
import Conversations from 'pages/authenticated/settings/conversations/Conversations';
import BotSettings from 'pages/authenticated/settings/settings/BotSettings';
import DocsPage from 'pages/authenticated/docs-page/DocsPage';
import SingleAgent from 'pages/authenticated/settings/single-agent/SingleAgent';
import SingleForm from 'pages/authenticated/settings/single-form/SingleForm';
import FormLeads from 'pages/authenticated/settings/form-leads/FormLeads';
import ContactProfile from 'pages/authenticated/settings/contact-profile/ContactProfile';
import BotScript from 'pages/authenticated/bot-script/BotScript';
import Channels from 'pages/authenticated/settings/channels/Channels';
import DataPreview from 'pages/authenticated/settings/data-preview/DataPreview';
import PromptSettings from 'pages/authenticated/settings/prompt-settings/PromptSettings';
import CreateDerivedView from 'pages/authenticated/settings/create-derived-view/CreateDerivedView';

const ROUTES_MAP = {
  // Main layout
  '/dashboard': { element: <Dashboard />, layout: 'main' },
  '/users': { element: <Users />, layout: 'main' },
  '/groups': { element: <Users />, layout: 'main' },
  '/user-management': { element: <Users />, layout: 'main' },
  '/new-user': { element: <NewUser />, layout: 'main' },
  '/edit-user/:id': { element: <NewUser />, layout: 'main' },
  '/user/:id': { element: <UserProfile />, layout: 'main' },
  '/new-group': { element: <NewGroup />, layout: 'main' },
  '/edit-group/:id': { element: <NewGroup />, layout: 'main' },
  '/profile': { element: <Profile />, layout: 'main' },
  '/bots': { element: <Bots />, layout: 'main' },
  '/knowledge-base': { element: <KnowledgeBase />, layout: 'main' },
  '/knowledge-base/:id': { element: <KnowledgeBase />, layout: 'main' },
  '/settings/branding': { element: <Branding />, layout: 'main' },
  '/settings/chat-settings': { element: <ChatSettings />, layout: 'main' },
  '/variable-management': { element: <VariableManagement />, layout: 'main' },
  '/company-profile': { element: <CompanyProfile />, layout: 'main' },
  '/docs': { element: <DocsPage />, layout: 'main' },
  '/bot/agent/:id': { element: <SingleAgent />, layout: 'main' },
  '/bot/update-derived-view/:id/:agentId': {
    element: <CreateDerivedView />,
    layout: 'main',
  },
  '/bot/create-derived-view/:agentId': {
    element: <CreateDerivedView />,
    layout: 'main',
  },
  // Settings layout
  '/bot/analytics/:id': { element: <Analytics />, layout: 'settings' },
  '/bot/branding/:id': { element: <BotBranding />, layout: 'settings' },
  '/bot/conversation/:id': { element: <Conversations />, layout: 'settings' },
  '/bot/categories/:id': { element: <Categories />, layout: 'settings' },
  '/bot/theme/:id': { element: <ThemeSettings />, layout: 'settings' },
  '/bot/sensitive-keyword/:id': {
    element: <SensitiveKeyword />,
    layout: 'settings',
  },
  '/bot/terms-conditions/:id': {
    element: <TermsAndConditions />,
    layout: 'settings',
  },
  '/bot/voice-recording/:id': {
    element: <VoiceRecording />,
    layout: 'settings',
  },
  '/bot/link-to-agent/:id': { element: <LinkToAgent />, layout: 'settings' },
  '/bot/Workflow/:id': { element: <SettingsWorkflows />, layout: 'settings' },
  '/bot/form-responses/:id': { element: <FormResponses />, layout: 'settings' },

  '/bot/form/:botId/:formId': { element: <SingleForm />, layout: 'main' },
  '/bot/form-leads/:formId/:categoryId/:botId': {
    element: <FormLeads />,
    layout: 'main',
  },
  '/bot/new-form/:id': { element: <NewForm />, layout: 'settings' },
  '/bot/edit-form/:id/:formId': { element: <NewForm />, layout: 'settings' },
  '/bot/settings/:id': { element: <BotSettings />, layout: 'settings' },
  '/bot/data-preview/:botId': {
    element: <DataPreview />,
    layout: 'main',
  },
  '/bot/prompt-settings/:id': {
    element: <PromptSettings />,
    layout: 'main',
  },

  // Console Settings layout
  '/console/categories': { element: <Categories />, layout: 'console' },
  '/console/theme': { element: <ThemeSettings />, layout: 'console' },
  '/console/sensitive-keyword': {
    element: <SensitiveKeyword />,
    layout: 'console',
  },
  '/console/voice-recording': {
    element: <VoiceRecording />,
    layout: 'console',
  },
  '/console/link-to-agent': { element: <Channels />, layout: 'console' },
  '/console/Workflow': { element: <SettingsWorkflows />, layout: 'console' },
  '/console/settings/:id': { element: <BotSettings />, layout: 'console' },

  // No layout
  '/chat-console': { element: <ChatConsole />, layout: 'main' },
  '/user/chat-console': { element: <ChatConsole isUserChat />, layout: 'main' },
  '/user/chat-console/:id': {
    element: <ChatConsole hasBotId disableConsole isUserChat />,
    layout: 'main',
  },
  '/chat-console/:id': {
    element: <ChatConsole hasBotId disableConsole />,
    layout: 'main',
  },
  '/workflow': { element: <WorkflowProviderView />, layout: 'none' },
  '/workflow/:id': { element: <WorkflowProviderView />, layout: 'none' },
  '/bot/contact-profile/:formId/:chatId': { element: <ContactProfile /> },
  '/bot/script/:id': { element: <BotScript />, layout: 'main' },
  '/user/profile': { element: <Profile isUserChat />, layout: 'restricted' },
};
const BOT_SETTINGS_ROUTES = [
  '/bot/analytics/:id',
  '/bot/branding/:id',
  '/bot/conversation/:id',
  '/bot/categories/:id',
  '/bot/theme/:id',
  '/bot/sensitive-keyword/:id',
  '/bot/terms-conditions/:id',
  '/bot/voice-recording/:id',
  '/bot/link-to-agent/:id',
  '/bot/Workflow/:id',
  '/bot/form-responses/:id',
  '/bot/form/:botId/:formId',
  '/bot/form-leads/:formId/:categoryId/:botId',
  '/bot/new-form/:id',
  '/bot/edit-form/:id/:formId',
  '/bot/settings/:id',
  '/bot/contact-profile/:formId/:chatId',
  '/bot/script/:id',
  '/bot/data-preview/:botId',
  '/bot/agent/:id',
  '/bot/update-derived-view/:id/:agentId',
  '/bot/create-derived-view/:agentId',
  '/bot/prompt-settings/:id',
];
const CONSOLE_SETTINGS_ROUTES = [
  '/console/categories',
  '/console/theme',
  '/console/sensitive-keyword',
  '/console/voice-recording',
  '/console/link-to-agent',
  '/console/Workflow',
  '/console/settings/:id',
  '/console/form-responses',
  '/console/new-form',
  '/console/edit-form/:formId',
  '/console/conversation',
  '/chat-console/:id',
  '/bot/script/:id',
];
const NONE_LAYOUT_BOT_ROUTES = ['/workflow', '/workflow/:id'];
const AGENT_ROUTES = [];
const RESTRICTED_ROUTES = [
  '/user/chat-console',
  '/user/chat-console/:id',
  '/user/profile',
];

export {
  NONE_LAYOUT_BOT_ROUTES,
  BOT_SETTINGS_ROUTES,
  RESTRICTED_ROUTES,
  CONSOLE_SETTINGS_ROUTES,
  ROUTES_MAP,
  AGENT_ROUTES,
};
